import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import image from "../../img/logo.png";
import { getToken, URL } from "../../utils";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FactureDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [facture, setFacture] = useState(null);
  const [setClientsParticuliers] = useState([]);
  const [articlesMagasin, setArticlesMagasin] = useState([]);
  const [username, setUsername] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const token = getToken();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(URL + "authentification/user-info", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setUsername(response.data.username);
      } catch (err) {
        // Optionnel: gestion d'erreur
      }
    };
    fetchUserInfo();
  }, [token]);

  useEffect(() => {
    const fetchArticlesMagasin = async () => {
      if (!facture || !facture.magasin) return;

      try {
        const response = await axios.get(
          `${URL}Magasins/articles-magasin/${facture.magasin}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setArticlesMagasin(response.data.stock_items);
      } catch (error) {
        console.error("Erreur lors de la récupération des articles :", error);
      }
    };

    fetchArticlesMagasin();
  }, [facture, token]);

  useEffect(() => {
    const fetchFactureDetails = async () => {
      try {
        const response = await axios.get(
          `${URL}Declarations/ventes/details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFacture(response.data);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des détails de la facture:",
          error
        );
      }
    };

    const fetchClientsParticuliers = async () => {
      try {
        const response = await axios.get(
          `${URL}Clients/clients-particuliers-list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClientsParticuliers(response.data);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des clients particuliers:",
          error
        );
      }
    };

    fetchFactureDetails();
    fetchClientsParticuliers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Fonction pour imprimer la facture
  const handlePrint = async () => {
    setIsPrinting(true);
    try {
      const response = await axios.get(
        `${URL}Declarations/ventes/telecharger-facture/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important pour les fichiers
        }
      );

      // Créer une URL pour le blob
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));

      // Ouvrir le PDF dans une nouvelle fenêtre pour l'impression
      const printWindow = window.open(fileURL, "_blank");

      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
          // Nettoyer l'URL après un délai
          setTimeout(() => {
            window.URL.revokeObjectURL(fileURL);
          }, 1000);
        };
      } else {
        toast.error(
          "Impossible d'ouvrir la fenêtre d'impression. Veuillez vérifier les paramètres de votre navigateur."
        );
        window.URL.revokeObjectURL(fileURL);
      }
    } catch (error) {
      console.error("Erreur lors de l'impression de la facture:", error);
      toast.error("Erreur lors de l'impression de la facture");
    } finally {
      setIsPrinting(false);
    }
  };

  // Fonction pour télécharger la facture
  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await axios.get(
        `${URL}Declarations/ventes/telecharger-facture/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob", // Important pour les fichiers
        }
      );

      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Facture_${facture.num_facture}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Facture téléchargée avec succès");
    } catch (error) {
      console.error("Erreur lors du téléchargement de la facture:", error);
      toast.error("Erreur lors du téléchargement de la facture");
    } finally {
      setIsDownloading(false);
    }
  };

  if (!facture) {
    return <div>Chargement...</div>;
  }

  const translatedFacture = {
    ...facture,
    on_gozem: facture.on_gozem === true ? "Oui" : "Non",
    lieu_conso: facture.lieu_conso === "on_place" ? "Sur place" : "Emporté",
    type_paiement:
      facture.type_paiement === "espece"
        ? "Espèce"
        : facture.type_paiement === "carte"
        ? "Carte bancaire"
        : facture.type_paiement === "mobile"
        ? "Mobile Money"
        : facture.type_paiement === "cheque"
        ? "Chèque"
        : facture.type_paiement,
    etat_paiement:
      facture.etat_paiement === "paye"
        ? "Payé"
        : facture.etat_paiement === "non_paye"
        ? "Non payé"
        : facture.etat_paiement === "partiel"
        ? "Partiel"
        : facture.etat_paiement,
  };

  return (
    <div className="p-4 w-full max-w-4xl mx-auto mt-6 bg-white shadow-md rounded-md h-full md:h-auto">
      {" "}
      <div className="flex flex-col sm:flex-row gap-3 mb-4 print:hidden">
        <button
          onClick={() => navigate("/sales")}
          className="p-2 px-4 rounded-md text-white bg-amber-600 hover:bg-amber-700 focus:ring-2 focus:ring-amber-600 focus:ring-offset-2 transition-colors duration-200"
        >
          <svg
            className="w-5 h-5 inline-block mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg>
          Retour
        </button>

        <button
          onClick={handleDownload}
          disabled={isDownloading}
          className={`p-2 px-4 rounded-md text-white transition-colors duration-200 ${
            isDownloading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700 focus:ring-2 focus:ring-green-600 focus:ring-offset-2"
          }`}
        >
          {isDownloading ? (
            <>
              <svg
                className="w-5 h-5 inline-block mr-2 animate-spin"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Téléchargement...
            </>
          ) : (
            <>
              <svg
                className="w-5 h-5 inline-block mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Télécharger PDF
            </>
          )}
        </button>
      </div>
      <div className="header flex justify-between items-center mb-4">
        <div className="flex items-center justify-center overflow-hidden h-24 my-4">
          <img
            src={image}
            alt="Logo de l'hôtel"
            className="logo w-auto h-64 -translate-x-8"
          />
        </div>
        <div className="invoice-info text-right">
          <div>
            Facture N°
            <span className="invoice-number font-bold text-xl">
              {facture.num_facture}
            </span>
          </div>
          <div>
            Date d'émission:{" "}
            <span>{new Date(facture.date_sortie).toLocaleDateString()}</span>
          </div>
        </div>
      </div>
      <div className="client-info mb-6">
        <span className="text-base text-gray-500">
          <span className="font-medium">Nom du magasinier :</span> {username}
        </span>
        <br />
        <br />
        <h2 className="text-lg font-semibold mb-3">Informations Client</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p>
              <strong>Nom:</strong> {facture.client_nom}
            </p>
            <p>
              <strong>Adresse:</strong> {facture.adresse_facturation}
            </p>
            <p>
              <strong>Lieu de consommation:</strong>{" "}
              {translatedFacture.lieu_conso}
            </p>
            <p>
              <strong>Commande via Gozem:</strong> {translatedFacture.on_gozem}
            </p>
          </div>
          <div>
            <p>
              <strong>Type de paiement:</strong>{" "}
              {translatedFacture.type_paiement}
            </p>
            {facture.client_professionnel && (
              <p>
                <strong>État de paiement:</strong>{" "}
                <span
                  className={`px-2 py-1 rounded text-sm font-medium ${
                    facture.etat_paiement === "paye"
                      ? "bg-green-100 text-green-800"
                      : facture.etat_paiement === "non_paye"
                      ? "bg-red-100 text-red-800"
                      : "bg-yellow-100 text-yellow-800"
                  }`}
                >
                  {translatedFacture.etat_paiement}
                </span>
              </p>
            )}
            {facture.remise > 0 && (
              <p>
                <strong>Remise:</strong> {facture.remise} FCFA
              </p>
            )}
            {facture.commentaire && facture.commentaire !== "null" && (
              <p>
                <strong>Commentaire:</strong> {facture.commentaire}
              </p>
            )}
          </div>
        </div>
      </div>
      <table className="w-full border-collapse border border-gray-300 mb-6">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">Description</th>
            <th className="border p-2 text-right">Prix Unitaire</th>
            <th className="border p-2 text-right">Quantité</th>
            <th className="border p-2 text-right">Unité</th>
            <th className="border p-2 text-right">Total HT</th>
          </tr>
        </thead>
        <tbody>
          {facture.sorties.map((sortie) => {
            const article = articlesMagasin.find(
              (item) => item.id === sortie.stock_item
            );
            return (
              <tr key={sortie.id}>
                <td className="border p-2">
                  {article ? article.nom : `Article ${sortie.stock_item}`}
                </td>
                <td className="border p-2 text-right">
                  {(sortie.prix_total / sortie.quantite).toFixed(2)} FCFA
                </td>
                <td className="border p-2 text-right">{sortie.quantite}</td>
                <td className="border p-2 text-right">{sortie.unite}</td>
                <td className="border p-2 text-right">
                  {sortie.prix_total} FCFA
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <br />
      <br />
      <div className="summary">
        <table className="summary-container w-full max-w-md ml-auto">
          <tbody>
            {facture.remise > 0 && (
              <tr className="summary-row">
                <td className="py-1">Sous-total:</td>
                <td className="summary-value text-right">
                  {facture.prix_total + facture.remise} FCFA
                </td>
              </tr>
            )}
            {facture.remise > 0 && (
              <tr className="summary-row">
                <td className="py-1">Remise:</td>
                <td className="summary-value text-right text-green-600">
                  - {facture.remise} FCFA
                </td>
              </tr>
            )}
            <tr className="summary-row">
              <td className="py-1">Total HT:</td>
              <td className="summary-value text-right font-semibold">
                {facture.prix_total} FCFA
              </td>
            </tr>
            <tr className="summary-row border-t-2 border-gray-300">
              <td className="py-2 font-bold">Montant à payer:</td>
              <td className="summary-value text-right font-bold text-lg">
                {facture.montant_a_payer} FCFA
              </td>
            </tr>
            {facture.client_professionnel &&
              facture.etat_paiement === "partiel" && (
                <>
                  <tr className="summary-row bg-green-50">
                    <td className="py-1">Montant payé:</td>
                    <td className="summary-value text-right text-green-700 font-semibold">
                      {facture.montant_paye} FCFA
                    </td>
                  </tr>
                  <tr className="summary-row bg-red-50">
                    <td className="py-1">Reste à payer:</td>
                    <td className="summary-value text-right text-red-700 font-bold">
                      {facture.reste_a_payer} FCFA
                    </td>
                  </tr>
                </>
              )}
            {facture.client_professionnel &&
              facture.etat_paiement === "non_paye" && (
                <tr className="summary-row bg-red-50">
                  <td className="py-1">Statut:</td>
                  <td className="summary-value text-right text-red-700 font-bold">
                    Non payé
                  </td>
                </tr>
              )}
            {facture.client_professionnel &&
              facture.etat_paiement === "paye" && (
                <tr className="summary-row bg-green-50">
                  <td className="py-1">Statut:</td>
                  <td className="summary-value text-right text-green-700 font-bold">
                    Payé
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FactureDetails;
